import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fg",
  "use": "icon-fg-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"icon-fg\">\r\n<path d=\"M65.5,56.6c-1.7,0.6-1.3,0.7-3.4,0L5.8,33.3c-0.4-0.4-0.7-1.1-0.7-1.7c0-0.6,0.2-1.3,0.6-1.7L60.6,6.6c1.3-0.6,2.5-1,4.8,0\r\n\tl55.8,22.9c1,1,1,2.4,0.1,3.4L65.5,56.6z M67.2,120.1c0,1.4,1.2,2.5,2.5,2.5l53.5-27.9c2.1-1.3,2.5-3.6,2.5-7v-47\r\n\tc0-0.6-0.2-1.4-0.7-1.8c-0.5-0.5-1.2-0.7-1.8-0.7L69.7,60.7c-2.5,1-2.5,2.3-2.5,3.7V120.1L67.2,120.1z M58.2,60.7L4.7,38.2\r\n\tc-0.6,0-1.4,0.2-1.8,0.7c-0.5,0.5-0.7,1.2-0.7,1.8v54.1c0,0.5-0.3,1.4,2.5,2.5l53.5,25.3c1.4,0,2.5-1.2,2.5-2.5V64.4\r\n\tC60.7,62.9,60.7,61.7,58.2,60.7z M40.7,74C33.8,71,27,68,20.1,65c-1.2-0.5-1.7-0.7-1.7-1.6v-5.9c0-0.7,0.4-1.8,1.4-1.5l21.1,9.2\r\n\tc2,1,1.4,1.1,1.5,4.6v3C42.4,73.4,41.9,74.5,40.7,74L40.7,74z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fg.svg
// module id = Txwt
// module chunks = 164